<template>    
    <Toast />
    <div class="row">
        <div class="col">
            <h2 class="titre">Modification Service d'urgence</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :urgence="urgence" :isModifier="true"/>
    <ButtonBar @sauvegarder="sauvegarder" @fermer="fermer" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation" />     
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ButtonBar from '../../../components/dossier/Modifier/ButtonBarUrgence.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsUrgence.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
    components: {
        ButtonBar,
        ModifierChamps,
        DialogConfirmation,
    },
    data() {
        return {
            societesLibelles: [],
            societesMap: {},
            isSauvegardeEnCours: false,
        };
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
            urgence: 'urgence/urgence',
        })
  },   
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier un Urgence");
    this.isSauvegardeEnCours = true;
    this.$store.dispatch('urgence/consulterUrgenceAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site
    }).then(() => {
        this.isSauvegardeEnCours = false;
    });
  },
  methods: {
    sauvegarder() {
        this.isSauvegardeEnCours = true;        
        this.$store.commit('urgence/UPDATE_URGENCE',this.$refs.modifierChamps.getUrgenceLocal());             
        this.$store.dispatch('urgence/sauvegarderUrgenceAction', {
            cle: this.$route.params.cle,
            site: this.$route.params.site,
        }).then((res) =>{
            this.$root.$refs.messagesComp.messagesList = res.data.messages
            if (res?.data?.messages.length == 0) {
                this.$toast.add(
                {severity:'success', 
                summary: 'Modifier', 
                detail:"L'urgence a été modifié.", 
                life: 6000});
            }                 
            this.isSauvegardeEnCours = false;
        });
    }, 
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();           
    },                  
  },
  beforeRouteLeave (to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.urgence,
     this.$refs.modifierChamps.getUrgenceLocal());
  },   
};
</script>
